import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    blockSpaced: {
      paddingBlock: Spacings.s32,
      '@media screen and (max-width: 780px)': {
        paddingBlock: Spacings.s24,
      },
    },
  },
  { name: 'color-details' },
);
